module.exports = (RESTService, CountriesService) ->
  'ngInject'
  {
    service: (countryId) ->
      RESTService.service('cities', CountriesService.service().one(countryId))
  }
